<div class="flex-display height-100per" role="main" aria-label="Master Glossary">
  <div class="width-75 height-100per" *ngIf="outcome" id="scrollList">
    <div class="pr-5per pl-5per height-100per" >
    <div class="search_padding_top">
    <div>
      <div class="top-heading content-blue mb-24px" role="heading" aria-level="2">{{GlossaryTermFinderHeader}}</div>
      <div class="flex-display">
        <div class="width-84">
                 <input class="searchTopic"
                 [(ngModel)]="filter" (input)="applyFilter($event.target.value)" [placeholder]="PlaceholderLabel"
                 type="text">
        </div>
        <div>
          <button mat-button class="btn-cancel" (click)="resetSearchText()">
            {{resetButton}} Filter
          </button>
        </div>
      </div>
    </div>
  
    </div>
      <div id="glossaryTab" class="glossaryTab" *ngIf="GlossaryColumnlabels">
        <button class="tablinks active" (click)="findGlossary($event, 'glossary_codification')"> <span>{{GlossaryColumnlabels[0]}}&nbsp;<span class="lightGrey-color font-14">({{totalCodCount}})</span> </span></button>
        <button class="tablinks" (click)="findGlossary($event, 'glossary_op')"> <span>{{GlossaryColumnlabels[1]}} &nbsp;<span class="lightGrey-color font-14">({{totalOpCount}})</span></span></button>
        <button class="tablinks" (click)="findGlossary($event, 'glossary_cig')"> <span>{{GlossaryColumnlabels[2]}} &nbsp;<span class="lightGrey-color font-14">({{totalCigCount}})</span> </span></button>
      </div>
      <div *ngIf="resultCount>0; else noResults">
      <div id="glossary_codification" class="glossaryTabContent">
        <section *ngIf="codification">
          <div class="mt-50px" *ngIf="codGlossaryContentCount> 0;else noResults">
              <mat-list *ngFor="let group of codGlossaryContent">
                    <div class="flex-display">
                        <div class="leftBox" attr.id="{{group.key}}">
                          <span class="alphabets">{{group.key}}</span>
                        </div>

                      <div class="width-90">
                        <mat-accordion multi>
                          <mat-expansion-panel [expanded]="true" *ngFor="let contact of group.contacts" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header [aria-label]="contact.name" class="mataccordianHeader">
                              <div [innerHTML]="contact.formattedGlossaryTitle | highlightSearchTerm : filter" (click)="OpenLink($event,contact.name)"></div>
                            </mat-expansion-panel-header>
                            <div >
                            <p class="ml-32px close-nav-icon  glossary-p" >
                              <span *ngIf="contact.topic.length > 0" class="glossaryTermUsage right-Overlay pdf-link" id="glossary-term-usage" [topicData]="contact"
                                appHostListenerClick>{{glossaryTermUsage}}</span>
                              <span *ngIf="contact.topic.length == 0" class="text-transform-uppercase bold topic font-black">{{noLinks}}</span>
                            </p>
                            <p class="glossaryContent ml-32px  glossary-p" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" (click)="OpenLink($event,contact.name)" [innerHTML]="contact.capital"></p>
                          </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                    </div>
              </mat-list>
            <div class="glossary-border-bottom"></div>
          </div>
          <div [ngClass]="(totalCodCount>codGlossaryContentCount)?'align-item-single-line':''" >
            <div class="mt-4 width-65" *ngIf="(totalCodCount>codGlossaryContentCount)">
              <button mat-button class="btn-cancel button-center pb-1" (click)="loadNextPage('glossary_codification')">Load more</button>
            </div>
            <div class="links cursor-pointer flex-display pl-11rem font-16 float-R text-decoration-none" (click)="setFocus()" *ngIf="enableBackToTop && codGlossaryContentCount!=0">
              <span class="pr-0-5rem mt-2-6rem">Back to Top</span>
              <span>
                <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement arrow-up-icon mt-2" alt="right up">
              </span>
            </div>
          </div>
        </section>
      </div>
      <div id="glossary_op" class="glossaryTabContent">
        <section *ngIf="originalPronouncements">
          <div class="mt-50px" *ngIf="(opGlossaryContentCount > 0);else noResults">
            <mat-list *ngFor="let group of opGlossaryContent">
              <div class="flex-display">
                <div class="leftBox" attr.id="{{group.key}}">
                  <span class="alphabets">{{group.key}}</span>
                </div>
                <div class="width-90">
                  <mat-accordion multi>
                    <mat-expansion-panel [expanded]="true" *ngFor="let contact of group.contacts" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                      <mat-expansion-panel-header [aria-label]="contact.name" class="mataccordianHeader">
                        <div [innerHTML]="contact.formattedGlossaryTitle | highlightSearchTerm : filter" (click)="OpenLink($event,contact.name)"></div>
                      </mat-expansion-panel-header>
                      <div >
                      <p class="ml-32px close-nav-icon  glossary-p">
                        <span *ngIf="contact.topic.length > 0" class="glossaryTermUsage right-Overlay pdf-link" id="glossary-term-usage" [topicData]="contact" appHostListenerClick>{{glossaryTermUsage}}</span>
                        <span *ngIf="contact.topic.length == 0" class="text-transform-uppercase bold topic font-black">{{noLinks}}</span>
                      </p>
                      <p class="glossaryContent ml-32px  glossary-p" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" (click)="OpenLink($event,contact.name)" [innerHTML]="contact.capital"></p>
                    </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </mat-list>
            <div class="glossary-border-bottom"></div>
          </div>
          <div [ngClass]="(totalOpCount>opGlossaryContentCount)?'align-item-single-line':''">
            <div class="mt-4 width-65" *ngIf="(totalOpCount>opGlossaryContentCount)">
              <button mat-button class="btn-cancel button-center pb-1" (click)="loadNextPage('glossary_op')">Load more</button>
            </div>
            <div class="links cursor-pointer flex-display pl-11rem font-16 float-R text-decoration-none" (click)="setFocus()"  *ngIf="enableBackToTop && opGlossaryContentCount!=0">
              <span class="pr-0-5rem mt-2-6rem">Back to Top</span>
              <span>
                <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement arrow-up-icon mt-2" alt="right up">
              </span>
            </div>
          </div>
        </section>
      </div>
      <div id="glossary_cig" class="glossaryTabContent">
        <section *ngIf="comprehensiveImplementationGuide">
          <div class="mt-50px" *ngIf="cigGlossaryContentCount > 0;else noResults">
            <mat-list *ngFor="let group of cigGlossaryContent">
              <div class="flex-display">
                <div class="leftBox" attr.id="{{group.key}}">
                  <span class="alphabets">{{group.key}}</span>
                </div>
                <div class="width-90">
                  <mat-accordion multi>
                    <mat-expansion-panel [expanded]="true" *ngFor="let contact of group.contacts" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                      <mat-expansion-panel-header [aria-label]="contact.name" class="mataccordianHeader">
                        <div [innerHTML]="contact.formattedGlossaryTitle | highlightSearchTerm : filter" (click)="OpenLink($event,contact.name)"></div>
                      </mat-expansion-panel-header>
                      <div >
                      <p class="ml-32px close-nav-icon  glossary-p">
                        <span *ngIf="contact.topic.length > 0" class="glossaryTermUsage right-Overlay pdf-link" id="glossary-term-usage" [topicData]="contact" appHostListenerClick>{{glossaryTermUsage}}</span>
                        <span *ngIf="contact.topic.length == 0" class="text-transform-uppercase bold topic font-black">{{noLinks}}</span>
                      </p>
                      <p class="glossaryContent ml-32px  glossary-p" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" (click)="OpenLink($event,contact.name)"  [innerHTML]="contact.capital"></p>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </mat-list>
            <div class="glossary-border-bottom"></div>
          </div>
          <div [ngClass]="(totalCigCount>cigGlossaryContentCount)?'align-item-single-line':''">
            <div class="mt-4 width-65" *ngIf="(totalCigCount>cigGlossaryContentCount) ">
              <button mat-button class="btn-cancel button-center pb-1" (click)="loadNextPage('glossary_cig')">Load more</button>
            </div>
            <div class="links cursor-pointer flex-display pl-11rem font-16 float-R text-decoration-none" (click)="setFocus()" *ngIf="enableBackToTop && cigGlossaryContentCount!=0">
              <span class="pr-0-5rem mt-2-6rem">Back to Top</span>
              <span>
                <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement arrow-up-icon mt-2" alt="right up">
              </span>
            </div>
          </div>
        </section>
      </div>
      <div class="pb-2"></div>
    </div>
    <ng-template #noResults>
      <div  *ngIf="showNoCodResults || showNoOpResults || showNoCigResults">
        <p class="resultNotFound glossary-p">{{noFoundHeader}}
          <span *ngIf="filter!=''">
            "{{filter}}" 
          </span>
          <span *ngIf=" filter==''">
           <span *ngIf="codification && codSelectedAlphabet!=''">"{{selectedAlphabet}}"</span>
           <span *ngIf="originalPronouncements && opSelectedAlphabet!=''">"{{selectedAlphabet}}"</span>
           <span *ngIf="comprehensiveImplementationGuide && cigSelectedAlphabet!=''">"{{selectedAlphabet}}"</span>
          </span>
        </p>
        <span class="font-14">
          {{noFoundDescription}}
        </span>
      </div>
    </ng-template>
  </div>
  </div>
  <div class="al-right" *ngIf="outcome">
    <div class="pt-9rem display-grid justify-content-center">
      
    
    <div class="btn-row-margin" *ngFor="let i of [0, 1, 2, 3, 4, 5, 6];">
      <div class="flex-display ">
        <div *ngFor="let alphabet of alphabetsArray[i]">
          <div (click)="goLetter(alphabet)" class="btn-alphabets" [class.btn-selected-alphabet]="this.selectedAlphabet == alphabet" [class.disableAlphabet]="!availableAlphabetsList.includes(alphabet)">
            {{alphabet}}
          </div>
        </div>
      </div>
    </div>
    <div class="btn-row-margin pb-3">
      <div class="ml-68px">
        <button mat-button class="btn1-cancel" (click)="ResetAlphabet()">
          {{resetAlphabet}}
        </button>
      </div>
    </div>
  </div>
</div>
</div>
